export type AiEntityDescriptor = {
    name: string; // Canonical model name, e.g. "SupportClaim", "ProviderMessage".
    description?: string; // Optional human-readable description of the entity type.
};

/**
 * Minimal, hand-curated entity descriptions for AI.
 * dataJson shape varies by page / smart context (keyword matches + Attach picker).
 */
export const aiEntitySchemas: Record<string, Partial<AiEntityDescriptor>> = {
    Claim: {
        description:
            'High-level claim record. Context usually includes claim summary, recent workflow history, and professional claim form(s). May also include eligibilities, codings, messages, and user-attached payments/collection payments/transmissions/invoices/HL7/coding/message items when relevant.',
    },
    SupportClaim: {
        description:
            'Support-side claim record. Context usually includes claim summary, recent workflow history, and professional claim form(s). May also include eligibilities, codings, messages, and user-attached items when relevant.',
    },
    Message: {
        description:
            'Generic support message containing subject, body, sender, comments and linked entities such as claims and codings.',
    },
    ProviderPatientStatement: {
        description:
            'Patient statement data for provider-facing view: patient, billing provider, balance due, payment sources, and associated claims.',
    },
};
